<template>
    <b-modal :ref="_uid" title="Upload documents" hide-footer>
        <b-col sm="12">
            <b-row class="mt-3">
                <b-col sm="6">
                    <b-form-group
                        label-cols-sm="6"
                        :label="$t('createShipment.placeholder.Choose Type')"
                        label-align-sm="left"
                        label-for="chooseType"
                    >
                        <b-input-group size="sm">
                            <b-col sm="8">
                                <vSelect
                                    :dynamicWidth="false"
                                    :options="shipDocumentTypes"
                                    label="shipmentDocumentTypeName"
                                    v-model="shipmentDocumentType"
                                    :clearable="false"
                                    id="chooseType"
                                    :reduce="
                                        (shipmentDocumentTypes) =>
                                            shipmentDocumentTypes.shipmentDocumentTypeName
                                    "
                                    :placeholder="$t('createShipment.placeholder.Choose Type')"
                                />
                            </b-col>
                            <b-input-group-append>
                                <div>
                                    <font-awesome-icon icon="exclamation-circle" size="lg" />
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="6">
                    <b-form-group
                        label-cols-sm="6"
                        :label="$t('createShipment.placeholder.Choose File')"
                        label-align-sm="left"
                        label-for="chooseType"
                    >
                        <b-input-group size="sm">
                            <b-col sm="11">
                                <div>
                                    <input
                                        type="file"
                                        name="files"
                                        id="files"
                                        ref="files"
                                        accept="application/pdf"
                                        @change="handleFileUpload"
                                        :class="{
                                            'is-invalid': $v.file.$error
                                        }"
                                        @update="$v.file.$touch()"
                                    />
                                    <validationField
                                        fieldName="uploadDocument.label.File"
                                        :validator="$v.file"
                                        v-if="$v.file.$error"
                                    />

                                    <validationField
                                        fieldName="uploadDocument.label.File"
                                        :validator="$v.fileSize"
                                        v-if="$v.file.fileSize.$error"
                                    />
                                </div>
                            </b-col>
                            <b-input-group-append>
                                <div>
                                    <font-awesome-icon icon="exclamation-circle" size="lg" />
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-row>
                    <b-col sm="4 mt-3">
                        <button
                            type="submit"
                            class="btn btn-outline-primary form-control"
                            v-on:click="submitFiles()"
                        >
                            Upload
                            <font-awesome-icon pull="left" icon="upload" />
                        </button>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-modal>
</template>

<script>
import vSelect from './vSelect';
import { mapGetters } from 'vuex';
import store from '../store';
import uploadDocumentValidationMixin from '../mixins/uploadDocumentValidationMixin';
import validationField from '../components/Validation/ValidationField';
import {
    ACTIONS,
    MUTATIONS,
    CREATE_SHIPMENT_PREFIX,
    CORE_PREFIX,
    UPLOAD_DOCUMENT_PREFIX
} from '../store/constants';

export default {
    props: {
        shipmentId: { type: Number, required: true }
    },
    data() {
        return {
            file: '',
            fileSize: 0,
            shipmentDocumentType: 'Invoice',

            shipDocumentTypes: [
                { shipmentDocumentTypeId: 1, shipmentDocumentTypeName: 'Invoice' },
                { shipmentDocumentTypeId: 8, shipmentDocumentTypeName: 'Other' }
            ]
        };
    },

    components: {
        vSelect,
        validationField
    },

    mixins: [uploadDocumentValidationMixin],

    mounted() {
        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
    },
    computed: {
        ...mapGetters('uploadDocument', ['getUploadResponse'])
    },
    methods: {
        show() {
            this.$refs[this._uid].show();
        },
        handleFileUpload(e) {
            if (e.target.files[0]['type'] === 'application/pdf') {
                this.file = e.target.files[0];
                this.$v.file.$touch();
            } else {
                this.file = '';
                this.clearFile();
            }
        },
        clearFile() {
            const input = this.$refs.files;
            input.type = 'text';
            input.type = 'file';
        },

        submitFiles() {
            this.$v.$touch();

            if (this.$v.$anyError) {
                return;
            }

            if (this.file != '') {
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('shippingId', this.shipmentId);
                formData.append('type', this.shipmentDocumentType);

                this.$store.dispatch(
                    UPLOAD_DOCUMENT_PREFIX + ACTIONS.UPLOAD_DOCUMENT.POST_UPLOAD_DOCUMENT,
                    formData
                );

                this.$refs[this._uid].hide();
            }
        }
    }
};
</script>
